import React from "react";
import { Draggable } from "react-beautiful-dnd";
import { Card, CardContent, Typography, Grid } from "@mui/material";

// Leave the ContainerComponents thing as comment here for now.
const DraggableCard = ({ item, index, styles, width }) => {
  const style = [styles.card];
  if (item.correct && styles.correctCard) {
    style.push(styles.correctCard);
  }
  if (item.correct === false && styles.wrongCard) {
    style.push(styles.wrongCard);
  }
  return (
    <Draggable draggableId={`${item.id}`} index={index}>
      {(provided, snapshot) => {
        // If its full screen like its suppose to then keep the style from draggableProps
        // if (snapshot.isDragging) {
        //   provided.draggableProps.style.left = undefined;
        //   provided.draggableProps.style.top = undefined;
        // }
        return (
          <Grid
            item
            xs={width}
            key={item.id}
            role={undefined}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <div key={item.id} style={styles.cardRoot}>
              <Card sx={style}>
                <CardContent>
                  <Typography variant="body1">{item.text}</Typography>
                </CardContent>
              </Card>
            </div>
          </Grid>
        );
      }}
    </Draggable>
  );
};

export default DraggableCard;
